import axios from "../BASE_API";
import AuthHeader from "../AuthHeader";

export class ExperimentAPI {

  allExperiment: any = (data: any) => {
    return axios.post("/experiment/list", data, { headers: AuthHeader() });
  };

  experimentList: any = () => {
    return axios.get("/experiment/list", { headers: AuthHeader() });
  };

  activeExperimentList: any = () => {
    return axios.get("/experiment/activeList", { headers: AuthHeader() });
  };

  createNewExperiment: any = (data: any) => {
    return axios.post("/experiment/add", data, { headers: AuthHeader() });
  };

  getExperimentById: any = (id: number) => {
    return axios.get(`/experiment/details/${id}`, { headers: AuthHeader() });
  };

  updateExperiment: any = (data: any) => {
    return axios.put("/experiment/update", data, {
      headers: AuthHeader(),
    });
  };
}
